import React from 'react';
import { Phone, Car } from 'lucide-react';
import { translations } from '../utils/translations';
interface FinalCTAProps {
  lang: string;
}
export function FinalCTA({
  lang
}: FinalCTAProps) {
  const t = translations[lang as keyof typeof translations] || translations.en;
  return <section className="py-24 px-4 bg-brand-black relative overflow-hidden" data-id="element-31">
      {/* Decorative background element */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-brand-red/5 blur-[120px] rounded-full pointer-events-none" data-id="element-32"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-33">
        <h2 className="text-5xl md:text-6xl text-white mb-6 leading-tight" data-id="element-34">
          {t.ctaTitle1} <br className="hidden md:block" data-id="element-35" />
          <span className="text-brand-red" data-id="element-36">{t.ctaTitle2}</span>
        </h2>

        <p className="text-xl text-gray-300 font-body mb-12" data-id="element-37">{t.ctaSubtitle}</p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-38">
          <a href="tel:+17862232564" className="flex items-center justify-center w-full sm:w-auto px-8 h-16 bg-brand-red hover:bg-brand-darkred text-white text-xl font-heading tracking-wider rounded-md transition-colors shadow-lg" data-id="element-39">
            <Phone className="w-6 h-6 mr-3 fill-current" data-id="element-40" />
            {t.ctaTowing}
          </a>

          <a href="tel:+16783347552" className="flex items-center justify-center w-full sm:w-auto px-8 h-16 bg-transparent border-2 border-white hover:bg-white hover:text-brand-black text-white text-xl font-heading tracking-wider rounded-md transition-colors" data-id="element-41">
            <Car className="w-6 h-6 mr-3" data-id="element-42" />
            {t.ctaRent}
          </a>
        </div>
      </div>
    </section>;
}